import * as React from 'react';

interface Props {
  width: string;
  height: string;
  color: string;
}

export default ({width, height, color}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 17"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg">
      <g
        id="Soliplus-Mobile"
        stroke="none"
        stroke-width="1"
        fill={color}
        fill-rule="evenodd">
        <g
          id="3.2-notificationes_ON"
          transform="translate(-236.000000, -82.000000)"
          stroke="#FFFFFF"
          stroke-width="2">
          <g id="envelope_ic_off" transform="translate(237.000000, 83.000000)">
            <rect id="Rectangle" x="0" y="0" width="22" height="15" />
            <polyline id="Path-2" points="0 0 11 6.5 22 0" />
          </g>
        </g>
      </g>
    </svg>
  );
};
